// src/modules/inpatients/components/shared/FormFields.jsx
import { Calendar, Clock, ChevronDown } from "lucide-react";

const baseInputClass =
  "w-full rounded-lg border border-slate-300 bg-white px-3 py-2.5 text-sm text-slate-800 placeholder:text-slate-400 focus:border-teal-500 focus:outline-none focus:ring-2 focus:ring-teal-100 disabled:bg-slate-50 disabled:text-slate-400";

export function Field({ label, required, hint, className = "", children }) {
  return (
    <div className={className}>
      {label && (
        <label className="mb-1.5 block text-sm font-medium text-slate-700">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}
      {children}
      {hint && <p className="mt-1 text-xs text-slate-400">{hint}</p>}
    </div>
  );
}

export function TextInput({ className = "", ...props }) {
  return <input type="text" className={`${baseInputClass} ${className}`} {...props} />;
}

export function NumberInput({ className = "", ...props }) {
  return <input type="number" className={`${baseInputClass} ${className}`} {...props} />;
}

export function TextArea({ className = "", rows = 4, maxLength, value, ...props }) {
  return (
    <div className="relative">
      <textarea
        rows={rows}
        maxLength={maxLength}
        value={value}
        className={`${baseInputClass} resize-none ${className}`}
        {...props}
      />
      {maxLength && (
        <span className="pointer-events-none absolute bottom-2 right-3 text-xs text-slate-400">
          {(value || "").length}/{maxLength}
        </span>
      )}
    </div>
  );
}

export function Select({ className = "", children, ...props }) {
  return (
    <div className="relative">
      <select
        className={`${baseInputClass} appearance-none pr-9 ${className}`}
        {...props}
      >
        {children}
      </select>
      <ChevronDown
        size={16}
        className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-slate-400"
      />
    </div>
  );
}

export function DateInput({ className = "", ...props }) {
  return (
    <div className="relative">
      <input type="date" className={`${baseInputClass} pr-9 ${className}`} {...props} />
      <Calendar size={16} className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-slate-400" />
    </div>
  );
}

export function TimeInput({ className = "", ...props }) {
  return (
    <div className="relative">
      <input type="time" className={`${baseInputClass} pr-9 ${className}`} {...props} />
      <Clock size={16} className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-slate-400" />
    </div>
  );
}

export function DateTimeInput({ className = "", ...props }) {
  return (
    <div className="relative">
      <input type="datetime-local" className={`${baseInputClass} pr-9 ${className}`} {...props} />
      <Calendar size={16} className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 text-slate-400" />
    </div>
  );
}

export const inputClass = baseInputClass;
